document.querySelectorAll("details").forEach((menu) => {
  if (menu.querySelector("summary") && menu.querySelector("ul")) {
    let closeTimeout;

    menu.addEventListener("mouseenter", () => {
      clearTimeout(closeTimeout);
      menu.setAttribute("open", true);
    });

    menu.addEventListener("mouseleave", () => {
      closeTimeout = setTimeout(() => {
        menu.removeAttribute("open");
      }, 250);
    });
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const path = window.location.pathname;
  const body = document.querySelector("body");

  if (path.includes("/pages/contacto")) {
    body.setAttribute("data-page", "contacto");
  } else if (path.includes("/pages/historia")) {
    body.setAttribute("data-page", "historia");
  } else {
    body.removeAttribute("data-page");
  }
});




